import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import clientConfig from '../../client-config';

const ActiveUserSubscriptions = ({ userId }) => {
  const [subscriptions, setSubscriptions] = useState([]);

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const fetchSubscriptions = async () => {
    try {
      const response = await axios.get(
        `${clientConfig.backendHOST}/subscriptions/userSubscription`,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'x-auth-token': localStorage.token,
          },
          params: { onlyUser: userId },
        }
      );
      setSubscriptions(response.data);
    } catch (error) {
      console.error('Hiba történt az előfizetések lekérésekor:', error);
    }
  };

  const handleCancelSubscription = async (id) => {
    try {
      await axios.put(
        `${clientConfig.backendHOST}/subscriptions/userSubscription`,
        { id, canceled: 1 },
        {
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': localStorage.token,
          },
        }
      );
      fetchSubscriptions(); // Újratöltés a frissített adatokkal
    } catch (error) {
      console.error('Hiba történt az előfizetés lemondásakor:', error);
    }
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden', mt: 3 }}>
      <Typography variant='h6' sx={{ textAlign: 'center', mt: 2 }}>
        Aktív előfizetések
      </Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Előfizetés</TableCell>
              <TableCell>Megújul (naponta)</TableCell>
              <TableCell>Érvényesség kezdete</TableCell>
              <TableCell>Lejárat</TableCell>
              <TableCell>Állapot</TableCell>
              <TableCell>Lemondás</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {subscriptions.map((sub) => (
              <TableRow key={sub.id}>
                <TableCell>{sub.subscription_code}</TableCell>
                <TableCell>{sub.subscription_days}</TableCell>
                <TableCell>
                  {new Date(sub.valid_from).toLocaleDateString()}
                </TableCell>
                <TableCell>
                  {new Date(sub.valid_to).toLocaleDateString()}
                </TableCell>
                <TableCell>{sub.Status}</TableCell>
                <TableCell>
                  <Checkbox
                    checked={sub.canceled === 1}
                    onChange={() => handleCancelSubscription(sub.id)}
                    disabled={sub.canceled === 1} // Ha már lemondta, ne lehessen újra
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ActiveUserSubscriptions;
